
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifestyle/toplists",
      function () {
        return require("private-next-pages/lifestyle/toplists.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifestyle/toplists"])
      });
    }
  